// src/components/menus/ProfilePageSubMenu.tsx
import React from 'react';
import { Badge } from '@mui/material';
import { BeingsPageSubMenuButton } from '../common/Buttons';
import { SubMenuContainer, SubMenuCap } from './shared/MenuElements';

interface ProfilePageSubMenuProps {
  selectedTab: number;
  setSelectedTab: (tab: number) => void;
  unreadCount?: number;
  bottomBorder?: boolean;
  buttonBottomBorder?: boolean;
}

const ProfilePageSubMenu: React.FC<ProfilePageSubMenuProps> = ({
  selectedTab,
  setSelectedTab,
  unreadCount = 0,
  bottomBorder = true,
  buttonBottomBorder = false,
}) => (
  <SubMenuContainer bottomBorder={bottomBorder}>
    <BeingsPageSubMenuButton
      onClick={() => setSelectedTab(0)}
      isActive={selectedTab === 0}
      minWidth="158px"
      showBottomBorder={buttonBottomBorder}
    >
      PROFILE
    </BeingsPageSubMenuButton>

    <BeingsPageSubMenuButton
      onClick={() => setSelectedTab(1)}
      isActive={selectedTab === 1}
      minWidth="262px"
      showBottomBorder={buttonBottomBorder}
    >
      <Badge
        badgeContent={unreadCount}
        color="error"
        max={99}
        sx={{ '& .MuiBadge-badge': { fontSize: '0.7rem' } }}
      >
        NOTIFICATIONS
      </Badge>
    </BeingsPageSubMenuButton>

    <SubMenuCap />
  </SubMenuContainer>
);

export default ProfilePageSubMenu;
